import { render, staticRenderFns } from "./CategoryPromoForm.vue?vue&type=template&id=43d003aa"
import script from "./CategoryPromoForm.vue?vue&type=script&lang=js"
export * from "./CategoryPromoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports